import 'picturefill';
import '../../../vendor/jamel/images-lazy-load-bundle/Resources/public/js/images-lazy-load-bundle.min';
import cookieConsent from './cookieConsent';
import videolink from './videolink';
import videoTogglers from './video';
import Animated from './animated';
//import SmoothScroll from './smoothScroll';
import is from 'is_js';
import Counter from './counter';
import limitLines from './limitLines';
import {initSliders} from './_sliders';
import $ from 'jquery';
import initGalleries from './_galleries';
import animator from './class/Animator';
import {list as newsList} from './class/News';

window.a = new animator(document.body, 'a');
a.setAnimated('Waypoint', '.list--activities .list__item', {
    direction: 'both'
});
//a.setAnimated('Waypoint', '.card--tab', {
//    direction: 'both'
//});
//a.setAnimated('Waypoint', 'main > .project-page > *:not(:first-child):not(.section--counters), .card--project-split, ul', {
//    direction: 'both'
//});

function getCurrentRotation(el) {
    var st = window.getComputedStyle(el, null);
    var tm = st.getPropertyValue("-webkit-transform") ||
        st.getPropertyValue("-moz-transform") ||
        st.getPropertyValue("-ms-transform") ||
        st.getPropertyValue("-o-transform") ||
        st.getPropertyValue("transform") ||
        "none";
    if (tm != "none") {
        var values = tm.split('(')[1].split(')')[0].split(',');
        /*
        a = values[0];
        b = values[1];
        angle = Math.round(Math.atan2(b,a) * (180/Math.PI));
        */
        //return Math.round(Math.atan2(values[1],values[0]) * (180/Math.PI)); //this would return negative values the OP doesn't wants so it got commented and the next lines of code added
        var angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
        return (angle < 0 ? angle + 360 : angle); //adding 360 degrees here when angle < 0 is equivalent to adding (2 * Math.PI) radians before
    }
    return 0;
}

//import SimpleBar from 'simplebar';
//import customSelect from 'custom-select';
import Map from './class/Map';
//import WCAG from './class/WCAG';
//import Layout from './_layout';

window.initMap = () => {
    let maps = document.querySelectorAll('[data-js-map]');
    Array.from(maps).forEach((map) => {
        if (map.closest('.map-layout--long') !== null) {
            map.style.width = '100%';
            map.style.height = `${map.scrollWidth}px`;
        }
        map.obj = new Map(map);
        map.obj.initMap();
    })
}

const App = {
    init() {


        cookieConsent();

        videolink();
        videoTogglers();

        //if (is.not.touchDevice()) {
        //    SmoothScroll(document, 120, 12);
        //}
        initSliders();
        initGalleries();


        new Counter('[data-js-counter]');


        document.querySelector('.main-header__nav-toggler').addEventListener('click', () => {
            document.querySelector('.main-header').classList.toggle('main-header--open');
            document.body.classList.toggle('disable-scroll');
        });


        Array.from(document.querySelectorAll('[data-tab]')).forEach((tab) => {

            tab.addEventListener('click', (event) => {

                //document.querySelector('[data-tabs-active]').setAttribute('data-tabs-active', tab.getAttribute('data-tab'));


                let activeTab = document.querySelector("[data-tab-active]");
                if (activeTab) {
                    activeTab.removeAttribute('data-tab-active');
                }
                let activeTabContent = document.querySelector('[data-tab-content-active]');
                if (activeTabContent) {
                    activeTabContent.removeAttribute('data-tab-content-active');
                }

                if (activeTab !== tab) {
                    tab.toggleAttribute("data-tab-active");
                    document.querySelector(`[data-tab-content="${tab.getAttribute('data-tab')}"]`).toggleAttribute('data-tab-content-active');
                }
                setTimeout(() => {
                    Waypoint.refreshAll()

                }, 500);
            })
        });
        let rotatedHeader = document.querySelector('[data-header-slug="c300"], [data-header-slug="c200"]');
        if (rotatedHeader) {
            let rotated = rotatedHeader.querySelector('.header__logo');
            rotated.addEventListener('transitionend', () => {
                rotated.classList.remove('section__rotated--transition');
            })

            let cachedPageYOffset = 0;
            window.addEventListener("scroll", () => {
                let scrollDirection = cachedPageYOffset <= window.pageYOffset ? 1 : -1;
                let scrollDistance = window.pageYOffset - cachedPageYOffset;
                rotated.style.transform = `rotate(${getCurrentRotation(rotated) + scrollDistance / 2}deg)`;
                cachedPageYOffset = window.pageYOffset;
            });

        }
        a.object.dispatchEvent(a.customEvents['a:onLoad']);
        let intro = document.querySelector('.section--intro');
        let icons = document.querySelector('.main-header__icons');
        if (intro) {
            intro.style.height = `${document.documentElement.clientHeight - document.querySelector('.main-header').clientHeight}px`;
            icons.style.height = `${intro.clientHeight - icons.clientWidth - 15}px`;
        } else {
            icons.style.height = `${document.documentElement.clientHeight - 15 - document.querySelector('.main-header').clientHeight}px`;
        }

        if(document.querySelector(".section--counters")) {
            let computerCounters = getComputedStyle(document.querySelector(".section--counters"));
            let width = Math.ceil(
                parseFloat(computerCounters.getPropertyValue('height'))
                - parseFloat(computerCounters.paddingBottom)
                - parseFloat(getComputedStyle(document.querySelector(".section--counters")).paddingTop));

            if(document.querySelector(".section__caption--aside--right")) {
                document.querySelector(".section__caption--aside--right").style.width = `${width}px`;
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', App.init);

window.addEventListener('load', () => {

    if (document.querySelector(".section--counters")) {
        let computerCounters = getComputedStyle(document.querySelector(".section--counters"));
        let width = Math.ceil(
            parseFloat(computerCounters.getPropertyValue('height'))
            - parseFloat(computerCounters.paddingBottom)
            - parseFloat(getComputedStyle(document.querySelector(".section--counters")).paddingTop));
        if(document.querySelector(".section__caption--aside--right")) {
            document.querySelector(".section__caption--aside--right").style.width = `${width}px`;
        }
    }
})

//Layout();
//new WCAG();


// Custom Select
//customSelect('.custom-select, select.form-control')


//limitLines();

//projectsOverviewPage.init();

//const galleryOpts = {
// Whether pressing the arrow keys should move to the next/previous slide.
//arrowNavigation: true,
//};

//const luminousOpts = {
// These options have the same defaults and potential values as the Luminous class.
//};

//this.animatedElements = new Animated($('.animate'), { desktopWidth: 1024 });
//this.animatedElements.init();
